import React from 'react';
import { useAppSelector } from 'redux/hooks';
import { canonicalUrlSelector } from '@doda/common/src/redux/features/canonical';
import { DODA_SITE_DOMAIN } from '@doda/common/src/constants/urls';
import { BreadCrumb } from '@doda/common/src/interfaces/breadCrumb';

/**
 * BreadcrumbのProps
 * @param breadcrumbData パンくずリストデータ
 */
interface Props {
  breadcrumbData: BreadCrumb[];
}

export const BreadCrumbLd: React.FC<Props> = React.memo(
  ({ breadcrumbData }) => {
    const currentURL = useAppSelector(canonicalUrlSelector);

    const domain =
      DODA_SITE_DOMAIN[process.env.APP_ENV as keyof typeof DODA_SITE_DOMAIN] ||
      DODA_SITE_DOMAIN.Production;
    const list: {
      '@type': string;
      position: number;
      item: { '@id': string; name: string };
    }[] = [];

    breadcrumbData.forEach((bclist, index) => {
      list.push({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': `${domain}${bclist.breadCrumbLink}`,
          name: bclist.breadCrumbText,
        },
      });
    });

    const jsonData = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: list,
    };

    return (
      <>
        {currentURL ? (
          <script
            type="application/ld+json"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(jsonData),
            }}
          />
        ) : null}
      </>
    );
  }
);

BreadCrumbLd.displayName = 'BreadCrumbLd';
